export interface ErroreBackend {
  rete: boolean;
  codice: string | null;
  messaggio: string | null;
}

// Codici di ErrorApiDTO (Constants del backend) che in registrazione hanno un testo tradotto
export const MESSAGGI_ERRORE_REGISTRAZIONE: Record<string, string> = {
  '3002': 'erroreAccountEsistente',
  '6000': 'erroreDatiRegistrazione',
};

/**
 * Legge un HttpErrorResponse senza mai lanciare. Il corpo e' un ErrorApiDTO ({ errorCode, message }),
 * come testo con le richieste responseType text, come oggetto con quelle JSON; una pagina HTML del proxy
 * o l'errore standard di Spring (senza errorCode) non danno nessun messaggio da mostrare.
 */
export function leggiErroreBackend(errore: unknown): ErroreBackend {
  const { status, error } = (errore ?? {}) as { status?: unknown; error?: unknown };
  if (status === 0) {
    return { rete: true, codice: null, messaggio: null };
  }
  let corpo: unknown = error;
  if (typeof corpo === 'string') {
    try {
      corpo = JSON.parse(corpo);
    } catch {
      corpo = null;
    }
  }
  const { errorCode, message } = (corpo && typeof corpo === 'object' ? corpo : {}) as { errorCode?: unknown; message?: unknown };
  if (errorCode == null) {
    return { rete: false, codice: null, messaggio: null };
  }
  const messaggio = typeof message === 'string' && message.trim() ? message.trim() : null;
  return { rete: false, codice: String(errorCode), messaggio };
}

/**
 * Il recupero password risponde 200 con { esito: 300, messaggio } e testi fissi in italiano
 * (PasswordServiceImpl.requestPassReset): si riconoscono i due piu' frequenti. Il confronto evita la
 * lettera accentata, che con la codifica del backend puo' arrivare come "?".
 */
export function chiaveErroreRecuperoPassword(messaggio: string): string | null {
  if (messaggio?.includes('Nessun utente associato')) {
    return 'erroreRecuperoEmailSconosciuta';
  }
  if (messaggio?.includes('consentita la modifica della password')) {
    return 'erroreRecuperoAccountSocial';
  }
  return null;
}
